import closeNavMenu from "../ui/burger/burger";

const html = document.querySelector("html");
const searchBtns = document.querySelectorAll(".search-btn");
const searchBlock = document.querySelector(".search-block");
const searchBlockInput = document.querySelector(".search-block__input");
const searchBlockClear = document.querySelector(".search-block__icon-clear");
const searchBlockSearch = document.querySelector(".search-block__icon-search");

const burgerMenu = document.querySelector(".burger-menu");
const mainOverlay = document.querySelector(".main-overlay");

const closeSearchBlock = () => {
  searchBlock.classList.remove("is-active");
  html.classList.remove("lock");
  mainOverlay.classList.remove("is-active");
};

searchBtns.forEach((searchBtn) => {
  searchBtn.addEventListener("click", () => {
    searchBlock.classList.toggle("is-active");
    html.classList.toggle("lock");
    mainOverlay.classList.toggle("is-active");

    if (burgerMenu.classList.contains("is-active")) {
      closeNavMenu();
    }
  });
});

searchBlockInput.addEventListener("input", () => {
  if (searchBlockInput.value) {
    searchBlockClear.classList.add("is-active");
    searchBlockSearch.classList.remove("is-active");

    searchBlockClear.addEventListener("click", () => {
      searchBlockInput.value = "";
      searchBlockClear.classList.remove("is-active");
      searchBlockSearch.classList.add("is-active");
    });
  }
});

document.addEventListener("click", (e) => {
  if (e.target === mainOverlay) {
    closeSearchBlock();
  }
});

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    closeSearchBlock();
  }
});
